export const removeUnderscoreAndCapitalize = (text: string) => {
  const [first, second, third] = text.toLowerCase().split('_');
  return `${first[0].toUpperCase()}${first.slice(1)}${second[0].toUpperCase()}${second.slice(1)}${
    third ? third[0].toUpperCase() + third.slice(1) : ''
  }`;
};
